import React, { FC, memo } from 'react';

import Icon from 'components/Icons';

import { CurrentRatingStyled, RatingStarsStyled } from './styles';
import { ratingToPercent } from './ratingMath';
import colors from 'styles/colors';

interface Props {
  rating: number;
}

// eslint-disable-next-line no-magic-numbers
const STAR_INDICES = [1, 2, 3, 4, 5];

const starsRow = (color: string) =>
  STAR_INDICES.map((i) => <Icon key={i} type="starFill" color={color} />);

const RatingStars: FC<Props> = ({ rating }) => {
  const starsPercent = ratingToPercent(rating);

  return (
    <RatingStarsStyled>
      {starsRow(colors.gray_scale4)}
      <CurrentRatingStyled $width={starsPercent}>{starsRow(colors.brand_2)}</CurrentRatingStyled>
    </RatingStarsStyled>
  );
};

export default memo(RatingStars);
